export default __webpack_public_path__ + "static/media/peugeot.80d456f0.svg";